import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";

import { SpaceList } from "@/components/portal/spaces/SpaceList";
import { RequirePermission } from "@/components/portal/RequirePermission";

export const Route = createFileRoute("/portal/spaces/")({
  component: SpaceListPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): { groupAccess?: string; groupAccessName?: string } => ({
    groupAccess:
      typeof search.groupAccess === "string" && search.groupAccess.length > 0
        ? search.groupAccess
        : undefined,
    groupAccessName:
      typeof search.groupAccessName === "string" && search.groupAccessName.length > 0
        ? search.groupAccessName
        : undefined,
  }),
});

function SpaceListPage() {
  const { groupAccess, groupAccessName } = Route.useSearch();

  return (
    <>
      <Helmet>
        <title>Spaces</title>
      </Helmet>
      <RequirePermission resource="spaces" action="view">
        <SpaceList
          initialGroupAccessId={groupAccess}
          initialGroupAccessName={groupAccessName}
        />
      </RequirePermission>
    </>
  );
}
